import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/img/coppa.svg'
import _imports_1 from '@/img/chevron_left.svg'
import _imports_2 from '@/img/chevron_right.svg'
import _imports_3 from '@/img/medaglia1.svg'
import _imports_4 from '@/img/medaglia2.svg'
import _imports_5 from '@/img/medaglia3.svg'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "d-flex justify-content-center mt-3" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_5 = { class: "coppaTitle" }
const _hoisted_6 = { class: "monthNavigator mt-2" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "center" }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = {
  key: 1,
  class: "classifica"
}
const _hoisted_16 = { class: "clienti" }
const _hoisted_17 = { class: "mt-3" }
const _hoisted_18 = { class: "classificaList" }
const _hoisted_19 = {
  key: 0,
  class: "text-center"
}
const _hoisted_20 = {
  key: 1,
  class: "classificaItem"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "medaglia" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1)
const _hoisted_22 = { class: "detail" }
const _hoisted_23 = { class: "detailName" }
const _hoisted_24 = {
  key: 2,
  class: "classificaItem"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "medaglia" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_26 = { class: "detail" }
const _hoisted_27 = { class: "detailName" }
const _hoisted_28 = {
  key: 3,
  class: "classificaItem"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "medaglia" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1)
const _hoisted_30 = { class: "detail" }
const _hoisted_31 = { class: "detailName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: "Classifica migliori venditori (nelle prime 3 linee)",
            text: "Classifica migliori venditori (nelle prime 3 linee)"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args)))
        }, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.periodo), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
        }, _hoisted_13)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (!_ctx.venditori[0] && !_ctx.venditori[1] && !_ctx.venditori[2])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Nessun elemento",
                          text: "Nessun elemento"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.venditori[0])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.venditori[0].name), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.venditori[0].fatturato) + " €", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.venditori[1])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.venditori[1].name), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.venditori[1].fatturato) + " €", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.venditori[2])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.venditori[2].name), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.venditori[2].fatturato) + " €", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
    ])
  ]))
}